import {
	MODEL_LIST_ERROR,
	RECEIVE_MODEL_LIST,
	REQUEST_MODEL_LIST,
	RECEIVE_DELETE_MODEL,
} from "../actions/modelListActions";

import { RECEIVE_UPDATE_MODEL, RECEIVE_ADD_MODEL } from "../actions/activeModelActions";

import { RECEIVE_LOGOUT_USER } from "../actions/activeUserActions";

const initialModelListState = {
	isFetching: false,
	items: [],
	init: true,
	error: null,
};

export const modelListReducer = (state = initialModelListState, action) => {
	switch (action.type) {
		case REQUEST_MODEL_LIST:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true };
		case RECEIVE_MODEL_LIST:
			//sets new state and fetching ended
			return { ...state, items: action.payload, isFetching: false, init: false };
		case MODEL_LIST_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false, init: false };
		case RECEIVE_DELETE_MODEL:
			// filter deleted model from starte
			const newModels = state.items.filter(model => model._id !== action.payload);
			return { ...state, items: newModels };
		case RECEIVE_UPDATE_MODEL:
			//find updated model and insert updated values
			const updatedModels = state.items.map(model =>
				model._id === action.payload._id ? { ...model, ...action.payload } : model
			);
			return { ...state, items: updatedModels, isFetching: false };
		case RECEIVE_ADD_MODEL:
			//add action. paylaod to items
			return { ...state, items: [...state.items, action.payload], isFetching: false };
		case RECEIVE_LOGOUT_USER:
			//sets new state and fetching ended
			return { ...initialModelListState, isFetching: false };
		default:
			return state;
	}
};
